import { INotificationFeatures, IUserControlFeatures } from "../UserSlice"

export const getinitNotificationFeatures  = (): INotificationFeatures=>{
    return {
        accessNotificationBoard : false,
        viewNotify : false,
        createNotify : false,
        editNotify : false,
        deleteNotify: false,
        submitNotify : {
            level1: false,
            level2: false,
          },        
        assignNotify : {
            level1 : false,
            level2 : false
        },
        publishNotify :{
            level1 : false,
            level2 : false
        },
        rejectNotify : {
            level1 : false,
            level2 : false
        },
        recallNotify: {
            level1 : false,
            level2 : false
        }
    }
}

export const getinitUserControlFeatures = () : IUserControlFeatures =>{
    return {viewUserControl : false}
}